import { CopyOutlined, CopyTwoTone } from "@ant-design/icons";
import { Typography } from "antd";
import { FC } from "react";

const { Text } = Typography;

interface ShortenedTextWithCopyProps {
    text?: string | null;
    maxLength?: number;
}

/**
 * Displays text truncated to maxLength characters with ellipsis and copy-to-clipboard feature.
 */
export const ShortenedTextWithCopy: FC<ShortenedTextWithCopyProps> = ({ text, maxLength = 100 }) => {
    if (!text) {
        return <>-</>;
    }

    const displayText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    return (
        <Text
            copyable={{
                text: text,
                icon: [<CopyOutlined key="copyOutlined" />, <CopyTwoTone key="copyTwoTone" />],
                tooltips: ["Click to copy", "Copied"],
            }}
            className="w-full flex justify-between items-center"
        >
            {displayText}
        </Text>
    );
};
